import type { SVGProps } from "react";

type Props = SVGProps<SVGSVGElement>;

const stroke = {
  fill: "none" as const,
  stroke: "currentColor",
  strokeWidth: 1.4,
  strokeLinecap: "round" as const,
  strokeLinejoin: "round" as const,
};

export const Icon = {
  Copy: (p: Props) => (
    <svg viewBox="0 0 16 16" {...stroke} {...p}>
      <rect x="4.5" y="4.5" width="8" height="9" rx="1.2" />
      <path d="M3 11V3.5A1 1 0 0 1 4 2.5h7" />
    </svg>
  ),
  Check: (p: Props) => (
    <svg viewBox="0 0 16 16" {...stroke} strokeWidth={1.6} {...p}>
      <path d="M3 8.5l3.2 3L13 4.5" />
    </svg>
  ),
  Eye: (p: Props) => (
    <svg viewBox="0 0 16 16" {...stroke} {...p}>
      <path d="M1.5 8s2.4-4.5 6.5-4.5S14.5 8 14.5 8 12.1 12.5 8 12.5 1.5 8 1.5 8z" />
      <circle cx="8" cy="8" r="2" />
    </svg>
  ),
  EyeOff: (p: Props) => (
    <svg viewBox="0 0 16 16" {...stroke} {...p}>
      <path d="M2.5 3.5l11 9" />
      <path d="M6.4 5.5C3.6 6.6 1.5 8 1.5 8s2.4 4.5 6.5 4.5c1.2 0 2.3-.3 3.2-.7" />
      <path d="M9.5 4c4 .3 5 4 5 4s-.5 1-1.5 2" />
    </svg>
  ),
  External: (p: Props) => (
    <svg viewBox="0 0 16 16" {...stroke} {...p}>
      <path d="M9.5 3.5h3v3" />
      <path d="M12.5 3.5L7 9" />
      <path d="M12.5 9.5v2.5a1 1 0 0 1-1 1h-7a1 1 0 0 1-1-1v-7a1 1 0 0 1 1-1H7" />
    </svg>
  ),
  Lock: (p: Props) => (
    <svg viewBox="0 0 16 16" {...stroke} {...p}>
      <rect x="3.5" y="7" width="9" height="6.5" rx="1.2" />
      <path d="M5.5 7V5a2.5 2.5 0 0 1 5 0v2" />
    </svg>
  ),
  Sun: (p: Props) => (
    <svg viewBox="0 0 16 16" {...stroke} strokeWidth={1.5} {...p}>
      <circle cx="8" cy="8" r="3" />
      <path d="M8 1.5v1.5M8 13v1.5M14.5 8H13M3 8H1.5M12.6 3.4l-1 1M5.4 10.6l-1 1M12.6 12.6l-1-1M5.4 5.4l-1-1" />
    </svg>
  ),
  Moon: (p: Props) => (
    <svg viewBox="0 0 16 16" {...stroke} strokeWidth={1.5} {...p}>
      <path d="M13 9.5A5.5 5.5 0 0 1 6.5 3a5 5 0 0 0 0 10 5.5 5.5 0 0 0 6.5-3.5z" />
    </svg>
  ),
  Arrow: (p: Props) => (
    <svg viewBox="0 0 16 16" {...stroke} {...p}>
      <path d="M3.5 8h9" />
      <path d="M9 4.5l3.5 3.5L9 11.5" />
    </svg>
  ),
  Plus: (p: Props) => (
    <svg viewBox="0 0 16 16" {...stroke} {...p}>
      <path d="M8 3.5v9M3.5 8h9" />
    </svg>
  ),
  Heart: (p: Props) => (
    <svg viewBox="0 0 24 24" {...stroke} strokeWidth={1.6} {...p}>
      <path d="M5 9c0-2.5 2-4.5 4.5-4.5 1.4 0 2.5.6 3 1.5.5-.9 1.6-1.5 3-1.5C18 4.5 20 6.5 20 9c0 4-3 8-7.5 11C8 17 5 13 5 9z" />
    </svg>
  ),
};
